import { giftingConstants } from "../constants/giftingConstants";

const initialState = {
    formDetails: {
        step1: null,
        step2: null,
        step3: null,
        step4: null,
    }
}

const giftingReducer = (state = initialState, action) => {
    switch (action.type) {
        case giftingConstants.SET_GIFTING_FORM_DETAILS:
            return {
                ...state,
                ...action.payload
            }

        default:
            return state;
    }
}

export default giftingReducer;